export enum Pathname {
  phones = '/phones',
  tablets = '/tablets',
  accessories = '/accessories',
  favorites = '/favorites',
  cart = '/cart',
  home = '/home',
}
